import React from 'react';

import ClaimNumberContainer from '../ClaimNumberContainer';

import GenericClaimBarField from './GenericClaimBarField';

type ClaimNumberProps = {
  displayName?: string;
};

const ClaimNumber = ({ displayName = 'Claim Number' }: ClaimNumberProps) => {
  return <GenericClaimBarField title={displayName} content={<ClaimNumberContainer />} allowWrapping={false} />;
};

export default ClaimNumber;
